import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

export const billingApi = createApi({
  reducerPath: 'billingApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getCurrentSubscription: builder.query({
      query: () => 'internal/v1/billing/subscriptions/current',
    }),
  }),
});

export const { useGetCurrentSubscriptionQuery } = billingApi;
